import React, { useEffect, useState } from 'react';
import ResultLink from '../ResultLink';
import { unitConversion } from '../../helpers';

export const FeaturedCommunitySliderCard = props => {
  const { item, distanceUnit, isNearby, withoutSwiper, featuredItemsCta } = props;

  const ctaClick = (e) => {
    e.preventDefault();

    const { Boxever, _boxever_settings } = window;

    if (!Boxever || !_boxever_settings) {
      window.location = item.Link;
      return;
    }

    const eventToSend = {
      channel: 'WEB',
      type: 'Community_Carousel_Click',
      pos: window._boxever_settings.pointOfSale,
      browser_id: Boxever.getID()
    };

    Boxever.eventCreate(
      eventToSend,
      data => {
        window.location = item.Link;
      },
      'json'
    );
  }

  return (
    <>
      {isNearby ? (
        <a href={item.Link} onClick={ctaClick} className={`nearby-communities-row-headless__item ${withoutSwiper ? "without-swiper": ""}`}>
          <div className="nearby-communities-row-headless__picture-wrapper">
            <div className="nearby-communities-row-headless__item-image">
              <img src={item.Image} alt={item.Heading} />
            </div>
            <div className="nearby-communities-row-headless__item-image-active">
              <img src={item.Image} alt={item.Heading} />
            </div>
          </div>
          <div className="nearby-communities-row-headless__info">
            <div className="nearby-communities-row-headless__content">
              <h3 className="nearby-communities-row-headless__content-heading">
                <span>{item.Heading}</span>
              </h3>
              {item.LevelsOfCare && item.LevelsOfCare.length > 0 && (
                <ul>
                  {item.LevelsOfCare.map((level, i) => (
                    <li key={i}>{level}</li>
                  ))}
                  {item.Price && item.Price.length > 0 && (
                    <li className="nearby-communities-row-headless__price">Room rates start at {item.Price} /month</li>
                  )}
                </ul>
              )}
            </div>
            <span className="nearby-communities-row-headless__link">
              <span className="link__label">{featuredItemsCta}</span>
              <svg
                viewBox="0 0 11 18"
                width="7"
                height="17"
                role="presentation"
              >
                <use xlinkHref="#arrow-right"></use>
              </svg>
            </span>
          </div>
          <div className="nearby-communities-row-headless__slide-overlay"></div>
        </a>
      ) : (
        <a href={item.Link} onClick={ctaClick} className="community-row__item">
          <div className="community-row__picture-wrapper">
            <div className="community-row__item-image">
              <img src={item.Image} alt={item.Heading} />
            </div>
            <div className="community-row__item-image-active">
              <img src={item.Image} alt={item.Heading} />
            </div>
          </div>
          <div className="community-row__info">
            <div className="community-row__content">
              <h3 className="community-row__heading">
                <span>{item.Heading}</span>
              </h3>
              {item.LevelsOfCare && item.LevelsOfCare.length > 0 && (
                <ul>
                  {item.LevelsOfCare.map((level, index) => (
                    <li key={index}>{level}</li>
                  ))}
                  {item.Price && item.Price.length > 0 && (
                    <li className="nearby-communities-row-headless__price">Room rates start at {item.Price} /month</li>
                  )}
                </ul>
              )}
            </div>
            <span className="community-row__link">
              <span className="link__label">{featuredItemsCta}</span>
              <svg
                viewBox="0 0 11 18"
                width="7"
                height="17"
                role="presentation"
              >
                <use xlinkHref="#arrow-right"></use>
              </svg>
            </span>
          </div>
        </a>
      )}
    </>
  );
};

export default FeaturedCommunitySliderCard;
